/**
 * Copyright (c) 2023, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
 *
 * WSO2 LLC. licenses this file to you under the Apache License,
 * Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied. See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import { TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineSeparator } from "@mui/lab";
import PropTypes from "prop-types";
import React from "react";
import HistoryItem from "./HistoryItem";
import Constants from "../../constants";
import StatusBadge from "../StatusBadge";
import "./HistoryItem.css";

/**
 * HistoryItemTimelineWrapper component
 * Description - This component is used to display the history items in a timeline
 */
function HistoryItemTimelineWrapper({ history }) {

  return (
    <>
      { /* History items wrapped with Timeline */ }
      <TimelineItem>
        <TimelineSeparator>
          <TimelineDot variant="outlined" sx={ { borderColor: Constants.color[history.type], borderWidth: 1 } }>
            <StatusBadge status={ Constants.statusCode[history.type] } />
          </TimelineDot>
          <TimelineConnector sx={ { width: "1px" } } />
        </TimelineSeparator>
        <TimelineContent>
          { /* Render history item */ }
          <HistoryItem history={ history } />
        </TimelineContent>
      </TimelineItem>
    </>
  );
}

HistoryItemTimelineWrapper.propTypes = {
  history: PropTypes.object
};

export default HistoryItemTimelineWrapper;
